/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as ServicesServiceIdRouteImport } from './routes/services.$serviceId'
import { Route as ServicesServiceIdIndexRouteImport } from './routes/services.$serviceId.index'
import { Route as ServicesServiceIdImportRouteImport } from './routes/services.$serviceId.import'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesServiceIdRoute = ServicesServiceIdRouteImport.update({
  id: '/services/$serviceId',
  path: '/services/$serviceId',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesServiceIdIndexRoute = ServicesServiceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ServicesServiceIdRoute,
} as any)
const ServicesServiceIdImportRoute = ServicesServiceIdImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => ServicesServiceIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/sign-in': typeof SignInRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/services/$serviceId': typeof ServicesServiceIdRouteWithChildren
  '/services/$serviceId/import': typeof ServicesServiceIdImportRoute
  '/services/$serviceId/': typeof ServicesServiceIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/sign-in': typeof SignInRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/services/$serviceId/import': typeof ServicesServiceIdImportRoute
  '/services/$serviceId': typeof ServicesServiceIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/sign-in': typeof SignInRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/services/$serviceId': typeof ServicesServiceIdRouteWithChildren
  '/services/$serviceId/import': typeof ServicesServiceIdImportRoute
  '/services/$serviceId/': typeof ServicesServiceIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/sign-in'
    | '/events/$eventId'
    | '/services/$serviceId'
    | '/services/$serviceId/import'
    | '/services/$serviceId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/sign-in'
    | '/events/$eventId'
    | '/services/$serviceId/import'
    | '/services/$serviceId'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/sign-in'
    | '/events/$eventId'
    | '/services/$serviceId'
    | '/services/$serviceId/import'
    | '/services/$serviceId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  SignInRoute: typeof SignInRoute
  EventsEventIdRoute: typeof EventsEventIdRoute
  ServicesServiceIdRoute: typeof ServicesServiceIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/$serviceId': {
      id: '/services/$serviceId'
      path: '/services/$serviceId'
      fullPath: '/services/$serviceId'
      preLoaderRoute: typeof ServicesServiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/$serviceId/': {
      id: '/services/$serviceId/'
      path: '/'
      fullPath: '/services/$serviceId/'
      preLoaderRoute: typeof ServicesServiceIdIndexRouteImport
      parentRoute: typeof ServicesServiceIdRoute
    }
    '/services/$serviceId/import': {
      id: '/services/$serviceId/import'
      path: '/import'
      fullPath: '/services/$serviceId/import'
      preLoaderRoute: typeof ServicesServiceIdImportRouteImport
      parentRoute: typeof ServicesServiceIdRoute
    }
  }
}

interface ServicesServiceIdRouteChildren {
  ServicesServiceIdImportRoute: typeof ServicesServiceIdImportRoute
  ServicesServiceIdIndexRoute: typeof ServicesServiceIdIndexRoute
}

const ServicesServiceIdRouteChildren: ServicesServiceIdRouteChildren = {
  ServicesServiceIdImportRoute: ServicesServiceIdImportRoute,
  ServicesServiceIdIndexRoute: ServicesServiceIdIndexRoute,
}

const ServicesServiceIdRouteWithChildren =
  ServicesServiceIdRoute._addFileChildren(ServicesServiceIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  SignInRoute: SignInRoute,
  EventsEventIdRoute: EventsEventIdRoute,
  ServicesServiceIdRoute: ServicesServiceIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
